"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = customEvent;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));

function customEvent(eventName, endpoint, info) {
  // Cache the NWA library for linting issues.
  var _window = window,
      nwa = _window.nwa; // Publish the custom event with the provided info.

  if (nwa) {
    nwa.track(eventName, (0, _objectSpread2.default)({
      eventName: eventName,
      endpoint: endpoint
    }, info));
  }
}